import {defaultTheme} from '@stencil/build-theme';
// Icons
import HappyFlashIcon from '@stencil/icons/src/HappyFlashIcon/HappyFlashIcon';

import useNavigateToReviewPage from '@stencil/navigate-to-review-page-dweb';
// Styles
import * as S from './bookNowButton.styles';

export default function PreviousBookingBookNowButton({
  isOutline = false,
  isPrimary = true,
  btnText = 'Book Now',
  width = '65%',
  height = '4.2rem',
  borderRadius = '',
  isRedirectToReviewPage = true,
  onBookNowClick = () => {},
  ratePlanData = {},
  roomCode = '',
  searchType = '',
  promoCode = '',
}) {
  const [navigatorNew] = useNavigateToReviewPage();

  const navigateToReviewPageCaller = descBlockInput => {
    const {rootLevelInfo, ...selectedRoomData} = descBlockInput;
    navigatorNew({
      selectedRoomInfo: [
        {
          ...selectedRoomData,
        },
      ],
      rootLevelInfo: {
        ...rootLevelInfo,
      },
    });
  };

  const navigateToReviewPage = () => {
    onBookNowClick();
    if (isRedirectToReviewPage) {
      navigateToReviewPageCaller({
        ratePlanArr: [ratePlanData],
        roomLevelInfo: {roomCode: roomCode},
        rootLevelInfo: {searchType: searchType, promoCode},
      });
    }
  };

  return (
    <>
      {isPrimary && (
        <S.QuickBookBtn
          width={width}
          height={height}
          borderRadius={borderRadius}
          onClick={navigateToReviewPage}
        >
          <span
            style={{
              marginTop: '7px',
            }}
          >
            {
              <HappyFlashIcon
                height="1.5rem"
                width="1.5rem"
                margin="0 0.4rem 0 0"
                fill={defaultTheme.colors.goWhite.base}
              />
            }
          </span>
          {btnText}
        </S.QuickBookBtn>
      )}
      {isOutline && !isPrimary && (
        <div data-testid="book-now-button-previous" onClick={navigateToReviewPage}>
          {' '}
          <span>
            {
              <HappyFlashIcon
                height="1.2rem"
                width="1.2rem"
                margin="0.5rem 0.3rem 0 0"
                fill={defaultTheme.colors.goBrandBlue.base}
              />
            }
          </span>
          <S.BookNowCTA>{'Book Now'}</S.BookNowCTA>
        </div>
      )}
    </>
  );
}
